/* global L */
Wee.fn.extend('identoMap', {
	initMap: function() {
		var scope = this,
			priv = scope.$private;

		L.mapbox.accessToken = scope.accessToken;

		priv.map = L.mapbox.map('map', null, {
			zoomControl: false,
			zoomOffset: -1,
			})
			.setView([37.0902, -95.7129])
			.addLayer(L.mapbox.styleLayer('mapbox://styles/mapbox/streets-v11');

		priv.initMapMarkers();
		priv.bindMapMarkers();
		priv.bindMapControls();
	},
	unloadMap: function() {
		var priv = this.$private;

		$.events.off(false, '.map');

		if (priv.map) {
			priv.map.remove();

			priv.map = null;
		}
	}
}, {
	/**
	 * Init map markers
	 *
	 * @private
	 */
	initMapMarkers: function() {
		this.markerHere = L.mapbox.featureLayer()
			.addTo(this.map);

		this.markerHere.on('layeradd', function(e) {
			var marker = e.layer,
				iconStyle = {
					'className': 'map-icon -here',
					'html': '',
					'iconSize': null
				};

			marker.setIcon(L.divIcon(iconStyle));
		});

		this.markers = L.mapbox.featureLayer()
			.addTo(this.map);

		this.markers.on('layeradd', function(e) {
			var marker = e.layer,
				iconStyle = {
					'className': 'map-icon',
					'html': '',
					'iconSize': null
				};

			marker.setIcon(L.divIcon(iconStyle));
		});
	},

	/**
	 * Bind map markers
	 *
	 * @private
	 */
	bindMapMarkers: function() {
		var scope = this;

		scope.markers.on('click', function(e) {
			scope.highlightLocation(e.layer._leaflet_id);

			scope.panMap();
		});
	},

	/**
	 * Bind map marker controls
	 *
	 * @private
	 */
	bindMapControls: function() {
		var scope = this;

		$.events.on({
			'ref:mapZoomIn': {
				click: function() {
					scope.map.zoomIn();
				}
			},
			'ref:mapZoomOut': {
				click: function() {
					scope.map.zoomOut();
				}
			}
		}, {
			namespace: 'map'
		});
	},

	/**
	 * Update map
	 *
	 * @private
	 * @param {object} locations
	 */
	updateMap: function(locations) {
		var resultsApp = this.searchResultsApp;

		this.markers.setGeoJSON(locations);

		this.markerHere.setGeoJSON(
			resultsApp.$get('features')[resultsApp.$get('selected')]
		);

		this.map.fitBounds(
			this.markers.getBounds()
				.extend(this.markerHere.getBounds())
		);
	},

	/**
	 * Pan map to active marker
	 *
	 * @private
	 */
	panMap: function() {
		var scope = this;

		scope.markers.eachLayer(function(marker) {
			var iconStyle = {
				'className': 'map-icon',
				'html': '',
				'iconSize': null
			};

			if (marker._leaflet_id === scope.locationsApp.$get('active')) {
				iconStyle.className = 'map-icon -is-selected';

				scope.map.panTo(marker.getLatLng());
			}

			marker.setIcon(L.divIcon(iconStyle));
		});
	}
});